import loadableWithRetry from '../common/loadableWithRetry'

const Tooltip = loadableWithRetry(() => import('./Tooltip'))

export default Tooltip;
